import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import { Facebook, Instagram } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#000000',
        color: '#FFFFFF',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#FFD700', fontWeight: 700 }}>
              MIRMIRE
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: '#FFFFFF' }}>
              Your trusted sporting club
            </Typography>
            <Box sx={{ mt: 2 }}>
              <IconButton
                aria-label="Facebook"
                href="https://www.facebook.com/mirmiresc"
                target="_blank"
                sx={{
                  color: '#FFFFFF',
                  '&:hover': {
                    color: '#FFD700',
                  },
                  mr: 1,
                }}
              >
                <Facebook />
              </IconButton>
              <IconButton
                aria-label="Instagram"
                href="https://www.instagram.com/mirmiresc"
                target="_blank"
                sx={{
                  color: '#FFFFFF',
                  '&:hover': {
                    color: '#FFD700',
                  },
                }}
              >
                <Instagram />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#FFD700', fontWeight: 700 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Link
                component={RouterLink}
                to="/"
                sx={{
                  mb: 1,
                  color: '#FFFFFF',
                  textDecoration: 'none',
                  '&:hover': {
                    color: '#FFD700',
                  },
                }}
              >
                Home
              </Link>
              <Link
                component={RouterLink}
                to="/about"
                sx={{
                  mb: 1,
                  color: '#FFFFFF',
                  textDecoration: 'none',
                  '&:hover': {
                    color: '#FFD700',
                  },
                }}
              >
                About Us
              </Link>
              <Link
                component={RouterLink}
                to="/contact"
                sx={{
                  mb: 1,
                  color: '#FFFFFF',
                  textDecoration: 'none',
                  '&:hover': {
                    color: '#FFD700',
                  },
                }}
              >
                Contact
              </Link>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#FFD700', fontWeight: 700 }}>
              Contact Us
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, color: '#FFFFFF' }}>
              Email: mirmiresc@gmail.com
            </Typography>
            <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
              Leppävaara, Espoo
            </Typography>
            {/* <Box sx={{ mt: 2 }}>
              <Typography
                variant="body2"
                sx={{ color: '#FFD700', fontWeight: 700, fontSize: '0.7rem' }}
              >
                Interested in this project?
              </Typography> */}
            {/* <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                <Link
                  href="https://www.linkedin.com/in/sushil-bastola-411b50a6/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: '#FFFFFF',
                    textDecoration: 'none',
                    '&:hover': { color: '#0A66C2' },
                    fontWeight: 500,
                    fontSize: '0.7rem',
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    style={{ marginRight: 8 }}
                  >
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm15.5 11.268h-3v-5.604c0-1.337-.025-3.063-1.868-3.063-1.868 0-2.154 1.459-2.154 2.967v5.7h-3v-10h2.881v1.367h.041c.401-.761 1.379-1.563 2.838-1.563 3.034 0 3.595 1.997 3.595 4.59v5.606z" />
                  </svg>
                  Sushil Bastola
                </Link>
              </Box> */}
            {/* </Box> */}
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box
          sx={{
            borderTop: '1px solid #FFD700',
            mt: 4,
            pt: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
            © {new Date().getFullYear()} Mirmire. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
